// @ts-nocheck
import { get } from "@insite/client-framework/Services/ApiService";
import { GetReturnSlipApiParameter, ReturnSlipModel } from "@store/Framework/Types/ApiModels";
import { customInvoicesServiceUrl } from "@store/Framework/Services/ReturnRequestService";

export function getReturnSlip(parameter: GetReturnSlipApiParameter) {
    return get<ReturnSlipModel>(`${customInvoicesServiceUrl}/rma/${parameter.returnSlipId}`, parameter);
}
